import * as React from 'react';
import TabiCube from './TabiCube';
import TaxiAndHireHeader from './TaxiAndHireHeader';

interface Props {
  /** 旅CUBE版の内容に切り替えるフラグ。 */
  tabiCube?: boolean
}

/** タクシー・ハイヤー予約サービスのヘッダー。 */
const AirportTransferTaxiHeader: React.FC<Props> = (props: Props) => {
  return (
    <>
      {/* 旅CUBE版の場合。 */}
      { props.tabiCube && <TabiCube /> }
      {/* 通常（空港アクセスナビ版）の場合。 */}
      { !props.tabiCube && <TaxiAndHireHeader /> }
    </>
  );
};

export default AirportTransferTaxiHeader;
